import HeaderBasic from '@/components/HeaderBasic.vue'
import AddListing1 from '@/components/AddListing1'
import Basic1 from '@/components/basic1.vue'
import Basic2 from '@/components/basic2.vue'
import Basic3 from '@/components/basic3.vue'
import Basic4 from '@/components/basic4.vue'
import Basic5 from '@/components/basic5.vue'
import Scene from '@/components/scene.vue'
import Scene1 from '@/components/scene1.vue'
import Scene11 from '@/components/scene1.1.vue'
import Scene2 from '@/components/scene2.vue'
import Price1 from '@/components/price1.vue'
import Price2 from '@/components/price2.vue'
import Price4 from '@/components/price4.vue'
import Address from '@/components/address.vue'

export default [
    {
        path: '/addListing1',
        name: 'addListing1',
        components: {
          content: AddListing1,
          header: HeaderBasic,
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            next()
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/address',
        name: "adr",
        components: {
          content: Address
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            next()
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/basic1',
        name: "basic1",
        components: {
          content: Basic1
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/addListing1' || from.path == '/address' || from.path == '/basic2') {
              next()
            } else {
              next('/dashboard')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/basic2',
        name: 'basic2',
        components: {
          content: Basic2
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/address' || from.path == '/basic1' || from.path == '/basic3') {
              next()
            } else {
              next('/dashboard')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/basic3',
        name: 'basic3',
        components: {
          content: Basic3
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/basic2' || from.path == '/basic4') {
              next()
            } else {
              next('/dashboard')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/basic4',
        name: 'basic4',
        components: {
          header: HeaderBasic,
          content: Basic4
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/basic3' || from.path == '/basic5') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/basic5',
        name: 'basic5',
        components: {
          header: HeaderBasic,
          content: Basic5
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/basic4' || from.path == '/scene') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/scene',
        name: 'scene',
        components: {
          header: HeaderBasic,
          content: Scene
        },
        props: {
          header: {
            progress: true,
            content: true
          },
          btn: false
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/scene1' || from.path == '/addListing1') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/scene1',
        name: 'scene1',
        components: {
          header: HeaderBasic,
          content: Scene1
        },
        props: {
          header: {
            progress: true,
            content: true
          }
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            // FOR dev
              //next()
            // FOR prod
            if (from.path == '/scene' || from.path == '/scene11' || from.path == '/addListing1') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/scene11',
        name: 'scene11',
        components: {
          header: HeaderBasic,
          content: Scene11
        },
        props: {
          header: {
            progress: true,
            content: true
          }
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/scene1' || from.path == '/scene2'|| from.path == '/addListing1') { next() }
            else { next('/addListing1') }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/scene2',
        name: 'scene2',
        components: {
          header: HeaderBasic,
          content: Scene2
        },
        props: {
          header: {
            progress: true,
            content: true
          }
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/scene11' || from.path == '/price1' || from.path=='/scene' || from.path=='/scene1' || from.path=='/price4') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/price1',
        name: 'price1',
        components: {
          header: HeaderBasic,
          content: Price1
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/scene2' || from.path == '/price2' || from.path == '/addListing1' || from.path=='/price4') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/price2',
        name: 'price2',
        components: {
          header: HeaderBasic,
          content: Price2
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.path == '/price1' || from.path == '/terms') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/price4',
        name: 'price4',
        components: {
          header: HeaderBasic,
          content: Price4
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            // price3 is reserved for social media options but is skipped at the moment
            if (from.path == '/price2') {
              next()
            } else {
              next('/addListing1')
            }
          } else {
            next('/login')
          }
        }
      },
]


// WEBPACK FOOTER //
// ./src/router/listing/addListing/index.js